import type { ParseKeys } from 'i18next';
import { CallLogStatus } from '@/services/call-log-service/call-log-service.types';

// Options hold a dictionary key, not a label: `t()` at module level would run once at import
// and never follow the language. The component translates them at render.
type LabelKey = ParseKeys<'conversations'>;

interface FilterOption {
  value: string;
  labelKey: LabelKey;
}

export const CONVERSATION_TYPE_OPTIONS: FilterOption[] = [
  { value: 'TextConversation', labelKey: 'filters.type.TextConversation' },
  { value: 'AnalyticsCall', labelKey: 'filters.type.AnalyticsCall' },
  { value: 'AgentCall', labelKey: 'filters.type.AgentCall' },
  { value: 'ChatConversation', labelKey: 'filters.type.ChatConversation' },
  { value: 'EmailConversation', labelKey: 'filters.type.EmailConversation' },
];

// The mockup's chip row, minus its visit chip: no visit state is derivable.
//
// These chips are narrower than the status badges, on purpose, because the index accepts
// only `agent` and `status`. "Picked up by a clerk" is `agent`, so it excludes a department
// redirect, which carries no agent yet is badged as handed off. And "Resolved" returns rows
// badged handed off too, since a handed-off call is also a closed one and handoff outranks
// resolution in the badge. Labelling each chip after what it selects keeps the two from
// contradicting each other.
export type StatusChipId = 'all' | 'resolved' | 'clerk';

export const STATUS_CHIPS: {
  id: StatusChipId;
  status?: CallLogStatus;
  agent?: boolean;
}[] = [{ id: 'all' }, { id: 'resolved', status: 'resolved' }, { id: 'clerk', agent: true }];

export const STATUS_OPTIONS: FilterOption[] = [
  { value: 'live', labelKey: 'status.live' },
  { value: 'resolved', labelKey: 'status.resolved' },
];

export const AGENT_OPTIONS: FilterOption[] = [
  { value: 'ai', labelKey: 'filters.agent.ai' },
  { value: 'human', labelKey: 'filters.agent.human' },
];

export const LANGUAGE_OPTIONS: FilterOption[] = [
  { value: 'en-us', labelKey: 'filters.language.en-us' },
  { value: 'es-mx', labelKey: 'filters.language.es-mx' },
];
